import { Locale } from 'modules/i18n';

export const privateChainsTranslation = {
  [Locale.en]: {
    requestsTooltip: 'Your requests for the last 24 hours',
  },
};
